import { render, staticRenderFns } from "./LoginLayer.vue?vue&type=template&id=6aefce3c&scoped=true"
import script from "./LoginLayer.vue?vue&type=script&lang=js"
export * from "./LoginLayer.vue?vue&type=script&lang=js"
import style0 from "./LoginLayer.vue?vue&type=style&index=0&id=6aefce3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefce3c",
  null
  
)

export default component.exports